import(/* webpackMode: "eager" */ "/app/app/privacy-policy/page.js");
